"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/zh-TW.ts
var zh_TW_exports = {};
__export(zh_TW_exports, {
  AG_CHARTS_LOCALE_ZH_TW: () => AG_CHARTS_LOCALE_ZH_TW
});
module.exports = __toCommonJS(zh_TW_exports);
var AG_CHARTS_LOCALE_ZH_TW = {
  ariaAnnounceChart: "\u5716\u8868\uFF0C${seriesCount}[number] \u500B\u7CFB\u5217",
  ariaAnnounceFlowProportionLink: "\u9023\u7D50 ${index} / ${count}\uFF0C\u5F9E ${from} \u5230 ${to}\uFF0C${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u7BC0\u9EDE ${index} \u4E4B ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u5100\u8868\u677F\u5716\u8868, ${caption}",
  ariaAnnounceHierarchyChart: "\u968E\u5C64\u5716\u8868, ${caption}",
  ariaAnnounceHierarchyDatum: "\u5C64\u7D1A ${level}[number]\uFF0C${count}[number] \u500B\u5B50\u9805\u76EE\uFF0C${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u6309\u7A7A\u683C\u9375\u6216\u56DE\u8ECA\u9375\u5207\u63DB\u53EF\u898B\u6027",
  ariaLabelAddHorizontalLine: "\u6DFB\u52A0\u6C34\u5E73\u7DDA\u689D",
  ariaLabelAnnotationOptionsToolbar: "\u8A3B\u89E3\u9078\u9805",
  ariaLabelAnnotationSettingsDialog: "\u8A3B\u89E3\u8A2D\u5B9A",
  ariaLabelColorPicker: "\u984F\u8272\u9078\u64C7\u5668",
  ariaLabelFinancialCharts: "\u8CA1\u52D9\u5716\u8868",
  ariaLabelLegend: "\u5716\u4F8B",
  ariaLabelLegendItem: "${label}, \u5716\u4F8B\u9805\u76EE ${index}[number]\uFF0C\u7E3D\u5171 ${count}[number]",
  ariaLabelLegendItemUnknown: "\u672A\u77E5\u7684\u5716\u4F8B\u9805\u76EE",
  ariaLabelLegendPageNext: "\u4E0B\u4E00\u9801\u5716\u4F8B",
  ariaLabelLegendPagePrevious: "\u524D\u4E00\u5716\u4F8B\u9801\u9762",
  ariaLabelLegendPagination: "\u5716\u4F8B\u5206\u9801",
  ariaLabelNavigator: "\u5C0E\u822A\u5668",
  ariaLabelNavigatorMaximum: "\u6700\u5927\u503C",
  ariaLabelNavigatorMinimum: "\u6700\u5C0F",
  ariaLabelNavigatorRange: "\u7BC4\u570D",
  ariaLabelRangesToolbar: "\u7BC4\u570D",
  ariaLabelSettingsTabBar: "\u8A2D\u5B9A",
  ariaLabelZoomToolbar: "\u7E2E\u653E",
  ariaValuePanRange: "${min}[percent0to2dp] \u5230 ${max}[percent0to2dp]",
  contextMenuDownload: "\u4E0B\u8F7D",
  contextMenuPanToCursor: "\u5E73\u79FB\u5230\u6B64\u8655",
  contextMenuToggleOtherSeries: "\u5207\u63DB\u5176\u4ED6\u7CFB\u5217",
  contextMenuToggleSeriesVisibility: "\u5207\u63DB\u53EF\u898B\u6027",
  contextMenuZoomToCursor: "\u7E2E\u653E\u81F3\u6B64",
  dialogHeaderChannel: "\u983B\u9053",
  dialogHeaderDatePriceRange: "\u65E5\u671F\u548C\u50F9\u683C",
  dialogHeaderDateRange: "\u65E5\u671F\u7BC4\u570D",
  dialogHeaderFibonacciRange: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  dialogHeaderLine: "\u7DDA\u689D",
  dialogHeaderPriceRange: "\u50F9\u683C\u7BC4\u570D",
  dialogHeaderText: "\u6587\u5B57",
  dialogInputAlign: "\u5C0D\u9F4A",
  dialogInputColorPicker: "\u984F\u8272",
  dialogInputColorPickerAltText: "\u6587\u5B57\u984F\u8272",
  dialogInputExtendAbove: "\u5411\u4E0A\u64F4\u5C55",
  dialogInputExtendBelow: "\u64F4\u5C55\u81F3\u4E0B\u65B9",
  dialogInputExtendChannelEnd: "\u5EF6\u4F38\u901A\u9053\u672B\u7AEF",
  dialogInputExtendChannelStart: "\u5EF6\u4F38\u901A\u9053\u8D77\u9EDE",
  dialogInputExtendLeft: "\u5411\u5DE6\u5EF6\u4F38",
  dialogInputExtendLineEnd: "\u5EF6\u4F38\u7DDA\u6BB5\u672B\u7AEF",
  dialogInputExtendLineStart: "\u5EF6\u4F38\u7DDA\u689D\u8D77\u9EDE",
  dialogInputExtendRight: "\u5EF6\u4F38\u81F3\u53F3\u908A",
  dialogInputFibonacciBands: "\u983B\u5E36",
  dialogInputFibonacciBandsAltText: "\u6590\u6CE2\u90A3\u5951\u983B\u5E36",
  dialogInputFillColorPicker: "\u586B\u5145",
  dialogInputFillColorPickerAltText: "\u586B\u5145\u984F\u8272",
  dialogInputFontSize: "\u5927\u5C0F",
  dialogInputFontSizeAltText: "\u5B57\u9AD4\u5927\u5C0F",
  dialogInputLineStyle: "\u865B\u7DDA",
  dialogInputPosition: "\u4F4D\u7F6E",
  dialogInputReverse: "\u53CD\u5411",
  dialogInputShowFill: "\u986F\u793A\u586B\u5145",
  dialogInputStrokeWidth: "\u7C97\u7D30",
  dialogInputStrokeWidthAltText: "\u7DDA\u689D\u7C97\u7D30",
  iconAltTextAlignCenter: "\u7F6E\u4E2D",
  iconAltTextAlignLeft: "\u5DE6",
  iconAltTextAlignRight: "\u53F3",
  iconAltTextClose: "\u95DC\u9589",
  iconAltTextLineStyleDashed: "\u9577\u865B\u7DDA",
  iconAltTextLineStyleDotted: "\u77ED\u865B\u7DDA",
  iconAltTextLineStyleSolid: "\u5BE6\u7DDA",
  iconAltTextPositionBottom: "\u5E95\u90E8",
  iconAltTextPositionCenter: "\u4E2D\u5FC3",
  iconAltTextPositionTop: "\u9802\u7AEF",
  inputTextareaPlaceholder: "\u6DFB\u52A0\u6587\u5B57",
  measurerDateRangeBars: "${value}[number] \u6839\u689D",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u9AD4\u7A4D ${value}",
  overlayLoadingData: "\u6B63\u5728\u8F09\u5165\u6578\u64DA...",
  overlayNoData: "\u6C92\u6709\u8CC7\u6599\u53EF\u986F\u793A",
  overlayNoVisibleSeries: "\u6C92\u6709\u53EF\u898B\u7684\u7CFB\u5217",
  overlayUnsupportedBrowser: "\u700F\u89BD\u5668\u7248\u672C\u4E0D\u76F8\u5BB9\u3002\u8ACB\u5347\u7D1A\u60A8\u7684\u700F\u89BD\u5668\u3002",
  seriesHistogramTooltipCount: "${yName} (\u8A08\u6578)",
  seriesHistogramTooltipFrequency: "\u983B\u7387",
  seriesHistogramTooltipMean: "${yName} (\u5E73\u5747\u503C)",
  seriesHistogramTooltipSum: "${yName} (\u7E3D\u548C)",
  toolbarAnnotationsArrow: "\u7BAD\u982D",
  toolbarAnnotationsArrowDown: "\u4E0B\u7BAD\u982D",
  toolbarAnnotationsArrowUp: "\u5411\u4E0A\u7BAD\u982D",
  toolbarAnnotationsCallout: "\u6CE8\u91CB",
  toolbarAnnotationsClearAll: "\u5168\u90E8\u6E05\u9664",
  toolbarAnnotationsComment: "\u8A3B\u89E3",
  toolbarAnnotationsDatePriceRange: "\u65E5\u671F\u548C\u50F9\u683C",
  toolbarAnnotationsDateRange: "\u65E5\u671F\u7BC4\u570D",
  toolbarAnnotationsDelete: "\u522A\u9664",
  toolbarAnnotationsDisjointChannel: "\u975E\u9023\u7E8C\u901A\u9053",
  toolbarAnnotationsDragHandle: "\u5DE5\u5177\u6B04\u62D6\u66F3",
  toolbarAnnotationsFibonacciAnnotations: "\u6590\u6CE2\u90A3\u5951",
  toolbarAnnotationsFibonacciRetracement: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u6590\u6CE2\u90A3\u5951\u8DA8\u52E2\u57FA\u7DDA",
  toolbarAnnotationsFillColor: "\u586B\u5145\u984F\u8272",
  toolbarAnnotationsHorizontalLine: "\u6C34\u5E73\u7DDA",
  toolbarAnnotationsLineAnnotations: "\u8DA8\u52E2\u7DDA",
  toolbarAnnotationsLineColor: "\u7DDA\u689D\u984F\u8272",
  toolbarAnnotationsLineStrokeWidth: "\u7DDA\u689D\u7C97\u7D30",
  toolbarAnnotationsLineStyle: "\u7DDA\u689D\u6A23\u5F0F",
  toolbarAnnotationsLock: "\u9396\u5B9A",
  toolbarAnnotationsMeasurerAnnotations: "\u6E2C\u91CF\u5DE5\u5177",
  toolbarAnnotationsNote: "\u8A3B\u89E3",
  toolbarAnnotationsParallelChannel: "\u5E73\u884C\u901A\u9053",
  toolbarAnnotationsPriceRange: "\u50F9\u683C\u7BC4\u570D",
  toolbarAnnotationsQuickDatePriceRange: "\u6E2C\u91CF",
  toolbarAnnotationsSettings: "\u8A2D\u5B9A",
  toolbarAnnotationsShapeAnnotations: "\u7BAD\u982D",
  toolbarAnnotationsText: "\u6587\u5B57",
  toolbarAnnotationsTextAnnotations: "\u6587\u5B57\u8A3B\u89E3",
  toolbarAnnotationsTextColor: "\u6587\u5B57\u984F\u8272",
  toolbarAnnotationsTextSize: "\u6587\u5B57\u5927\u5C0F",
  toolbarAnnotationsTrendLine: "\u8DA8\u52E2\u7DDA",
  toolbarAnnotationsUnlock: "\u89E3\u9396",
  toolbarAnnotationsVerticalLine: "\u5782\u76F4\u7DDA",
  toolbarRange1Month: "1\u6708",
  toolbarRange1MonthAria: "1\u500B\u6708",
  toolbarRange1Year: "1\u5E74",
  toolbarRange1YearAria: "1\u5E74",
  toolbarRange3Months: "3\u500B\u6708",
  toolbarRange3MonthsAria: "3\u500B\u6708",
  toolbarRange6Months: "6\u500B\u6708",
  toolbarRange6MonthsAria: "6\u500B\u6708",
  toolbarRangeAll: "\u5168\u90E8",
  toolbarRangeAllAria: "\u5168\u90E8",
  toolbarRangeYearToDate: "\u5E74\u521D\u81F3\u4ECA",
  toolbarRangeYearToDateAria: "\u4ECA\u5E74\u8FC4\u4ECA",
  toolbarSeriesTypeCandles: "\u881F\u71ED\u5716",
  toolbarSeriesTypeDropdown: "\u5716\u8868\u985E\u578B",
  toolbarSeriesTypeHighLow: "\u9AD8\u4F4E",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u7A7A\u5FC3\u881F\u71ED",
  toolbarSeriesTypeLine: "\u6298\u7DDA\u5716",
  toolbarSeriesTypeLineWithMarkers: "\u5E36\u6A19\u8A18\u7684\u6298\u7DDA\u5716",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u968E\u68AF\u7DDA",
  toolbarZoomPanEnd: "\u79FB\u52D5\u5230\u7D50\u5C3E",
  toolbarZoomPanLeft: "\u5411\u5DE6\u5E73\u79FB",
  toolbarZoomPanRight: "\u5411\u53F3\u5E73\u79FB",
  toolbarZoomPanStart: "\u79FB\u52D5\u5230\u8D77\u9EDE",
  toolbarZoomReset: "\u91CD\u8A2D\u7E2E\u653E",
  toolbarZoomZoomIn: "\u653E\u5927",
  toolbarZoomZoomOut: "\u7E2E\u5C0F",
  tooltipPaginationStatus: "${index}[number]\u4E2D\u7684${count}[number]"
};
//# sourceMappingURL=zh-TW.cjs.js.map
